import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";
import { ROLE_HOME, type Role } from "./types";

/**
 * Client-side route guard for UX (redirects unauthenticated users to login and
 * blocks wrong-role access). This is NOT the security boundary - the server
 * enforces access via RLS + edge functions (docs/SECURITY.md sec 1).
 */
export function ProtectedRoute({ allow }: { allow?: Role[] }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="grid min-h-[40vh] place-items-center text-brand-500">
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/app" replace state={{ from: location.pathname }} />;
  }

  if (allow && !allow.includes(user.role)) {
    return <Navigate to={ROLE_HOME[user.role]} replace />;
  }

  return <Outlet />;
}
